export function polyfill<O>(target: O, property: keyof O, implementation: any) {
  if (false === target.hasOwnProperty(property)) {
    target[property] = implementation;
  }
}



// WEBPACK FOOTER //
// ./src/polyfills/polyfill.ts